import React from 'react';
import {
    Container,
    MarginBox,
    SocialLinks,
    Links,
    Copyright,
} from './MobileFooter.style';
import { string } from 'prop-types';
import footerLinks from '../DesktopFooter/footerLinks';

const MobileFooter = ({ bgColor }) => {
    return (
        <Container bgColor={bgColor}>
            <MarginBox>

                <SocialLinks>
                    {footerLinks.social.map(social => (
                        <a key={social.alt} href={social.to} rel="noopener noreferrer" target="_blank">{social.logo}</a>
                    ))}
                </SocialLinks>
            </MarginBox>
            <Links to="/terms" key="terms">
                Termos e Condições
            </Links>
            <Links to="/privacy-policy" key="privacy-policy">
                Política de Privacidade
            </Links>
            <MarginBox>
                <Copyright style={{ marginTop: '20px' }}>@2020 Bizdocs. Todos os direitos reservados</Copyright>
            </MarginBox>    
        </Container>
    );
};

MobileFooter.propTypes = {
    bgColor: string
};

MobileFooter.defaultProps = {
    bgColor: '#1b2555'
};

export default MobileFooter;


/*<Container>
      <MarginBox>
        <AccordionFooter
          bgColor="#1b2555"
          title="Sobre o Bizdocs"
          paragraph={
            <>
                {footerLinks.about.map(link => (
                    <Links to={link.link} key={link.text}>
                        {t(link.text)}
                    </Links>
                ))}
            </>
          }
          color="#ABC6DE"
          width="100%"
          liColor="#1b2555"
          fontColor="#ffffff"
        />
        <AccordionFooter
          bgColor="#1b2555"
          title="Portal Gab. Contabilidade"
          paragraph={
            <>
                  {footerLinks.portal.map(link => (
                      <Links key={link.text} to=""> {t(link.text)}</Links>
                  ))}
            </>
          }
          color="#ABC6DE"
          width="100%"
          liColor="#1b2555"
          fontColor="#ffffff"
        />
        <AccordionFooter
          bgColor="#1b2555"
          title="Empresa - Mobi"
          paragraph={
            <>
                  {footerLinks.empresas.map(link => (
                      <Links key={link.text} to=""> {t(link.text)}</Links>
                  ))}
            </>
          }
          color="#ABC6DE"
          width="100%"
          liColor="#1b2555"
          fontColor="#ffffff"
        />
        <AccordionFooter
          bgColor="#1b2555"
          title="Login"
          paragraph={
            <>
                  {footerLinks.login.map(link => (
                      <Links key={link.text} to=""> {t(link.text)}</Links>
                  ))}
            </>
          }
          color="#ABC6DE"
          width="100%"
          liColor="#1b2555"
          fontColor="#ffffff"
        />

        <AccordionFooter
            bgColor="#1b2555"
            title="Contactos"
            paragraph={
                <>
                    <p style={{ marginTop: '10px' }}>+351 220 149 690</p>
                    <div style={{ marginTop: '10px' }}>
                        <FontAwesomeIcon icon={faEnvelope} />
                        <a href="mailto:info@bizdocs.mobi">info@bizdocs.mobi</a>
                    </div>
                </>
            }
            color="#ABC6DE"
            width="100%"
            liColor="#1b2555"
            fontColor="#ffffff"
        />
        <SocialLinks>
          {footerLinks.social.map(social => (
            <div key={social.alt}>{social.logo}</div>
          ))}
        </SocialLinks>
              <Title style={{ marginTop: '56px' }}>Powered by </Title>
              <img src={ImageLatourrette} alt="imag" style={{ maxHeight: '2.5vh' }} />
              <img src={Image2020} alt="imag" style={{ maxHeight: '3.5vh', marginTop: '20px' }} />
              <Copyright style={{ marginTop: '20px' }}>@2020 Bizdocs. Todos os direitos reservados</Copyright>      </MarginBox>
    </Container>*/